import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { Modal } from "react-bootstrap";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { deleteCategory, fetchAllCategory, updateCategory } from "helpers/category_helper";

const AllCategories = (props) => {
    document.title = "Content Management | All Categories";
    const [modalShow, setModalShow] = useState(false);
    const [categoryName, setCategoryName] = useState("");
    const [categoryDescription, setCategoryDescription] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    const [id, setId] = useState({});
    const [loader, setLoader] = useState(false);
    const [allCategory, setAllCategory] = useState([]);
    const [page, setPage] = useState(1);


    const breadcrumbItems = [
        { title: "Category", link: "#" },
        { title: "All Categories", link: "#" },
    ]

    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    useEffect(() => {
        props.setBreadcrumbItems('All Categories', breadcrumbItems);
    })

    const fetchCategories = async () => {
        try {
            const data = await fetchAllCategory();

            if (data?.success) {
                setAllCategory(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchCategories();
    }, []);

    const data = {
        columns: [
            {
                label: "Serial No.",
                field: "serialNo",
                sort: "asc",
                width: 50,
            },
            {
                label: "Name",
                field: "name",
                sort: "asc",
                width: 150,
            },
            {
                label: "Description",
                field: "description",
                sort: "asc",
                width: 200,
            },
        ],
        rows: allCategory,
        rows: allCategory?.map((row, index) => ({
            ...row,
            serialNo: index + 1, // Add 1 to start counting from 1
            clickEvent: () => handleRowClick(row)
        }))
    }

    const handleRowClick = (row) => {

        setModalShow(true);
        setId(row.id);
        setCategoryName(row.name);
        setCategoryDescription(row.description);
    }

    const handleUpdate = async () => {
        try {
            if (!categoryDescription || !categoryName) {
                setSpanDisplay("inline");
            }
            else {
                setLoader(true);
                const data = await updateCategory({ id, name: categoryName, description: categoryDescription });
                setLoader(false);
                if (data?.success) {
                    toast.success(data?.message);
                    setModalShow(false)
                    fetchCategories();
                }
                else {
                    toast.error(data?.message);
                }
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }


    const handleDelete = async () => {
        try {
            setLoader(true);
            const data = await deleteCategory(id);
            setLoader(false);
            if (data?.success) {
                toast.success(data?.message);
                setModalShow(false);
                setDeleteModalShow(false);
                fetchCategories();
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }




    return (
        <React.Fragment>

            {loader ? (
                <>
                    < Loader />
                </>
            ) : ("")}


            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4">All Categories </CardTitle>
                            <MDBDataTable
                                className="table-row-hover"
                                responsive
                                bordered
                                data={data}
                                style={{ cursor: 'pointer' }}
                                noBottomColumns
                                paging={{ page, onPageChange: setPage }}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Modal for edit category  */}
            <Modal
                show={modalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Category
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Category Name
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Class"
                                value={categoryName}
                                maxLength="50"
                                onChange={(e) => setCategoryName(e.target.value)} />
                            {!categoryName && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Category Description
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Description"
                                value={categoryDescription}
                                maxLength="50"
                                onChange={(e) => setCategoryDescription(e.target.value)} />
                            {!categoryDescription && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setModalShow(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdate} className="waves-effect waves-light">Update</Button>{" "}
                    <Button type="button" color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false) }} className="waves-effect waves-light">Delete</Button>{" "}

                </Modal.Footer>
            </Modal>


            {/* Modal for delete confirmation  */}
            <Modal
                show={deleteModalShow}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Category.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteModalShow(false); setModalShow(true) }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDelete} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal>

        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(AllCategories);